// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"734":"8d9f261c","990":"efa71e66"}[chunkId] + ".chunk.css";
};